// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2X7q5","header":"ReportDetails_header__24WI-","title":"ReportDetails_title__2JbQx","left":"ReportDetails_left__1F5jL"};